export default __webpack_public_path__ + "static/media/5_Aggressive.0aa2ec25.png";